import React from "react";
import {Badge, OptionComponentProps} from "peggirkit";
import {ProductReference} from "@/data/entities/product";
import {twJoin} from "tailwind-merge";
import {FormattedMessage} from "react-intl";
import {formatMoney} from "@/utils/MoneyUtils";

const ComboboxOption = ({
                            selected,
                            active,
                            disabled,
                            option,
                        }: OptionComponentProps<ProductReference>) => (
    <article
        className={twJoin(
            "w-full flex flex-col gap-1 py-2 px-4 text-black dark:text-white",
            disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
            selected
                ? "bg-gray-100 dark:bg-slate-600"
                : (active
                    ? "bg-gray-50 dark:bg-slate-700"
                    : "bg-white dark:bg-slate-800"),
        )}
    >
        <div className={"w-full flex flex-row items-center justify-between gap-2 "}>
            <div className={"flex flex-row items-center justify-start gap-2.5"}>
                <strong className={"font-medium"}>
                    {option.displayValue}
                </strong>

                {
                    (option.componentProps && option.componentProps.categoryNames.length > 0) &&
                    <Badge
                        size={"xs"}
                        color={"secondary"}
                    >
                        {option.componentProps.categoryNames[0]}
                    </Badge>
                }
            </div>

            {
                option.componentProps &&

                <div className={"font-medium text-[95%] text-gray-400 flex flex-row items-center justify-start"}>
                    {formatMoney(option.componentProps.price)}
                    {" / "}
                    {formatMoney(option.componentProps.priceTakeaway)}
                </div>
            }
        </div>


        {
            option.componentProps &&
            <small className={"text-xs text-gray-400"}>
                <FormattedMessage
                    id={"productIdAndExternal"}
                    values={{
                        productId: option.componentProps?.id,
                        productExternalId: option.componentProps?.externalId,
                    }}
                />
            </small>
        }
    </article>
);

export default ComboboxOption;